import { render, staticRenderFns } from "./productManager.vue?vue&type=template&id=2669f006&scoped=true"
import script from "./productManager.vue?vue&type=script&lang=js"
export * from "./productManager.vue?vue&type=script&lang=js"
import style0 from "./productManager.vue?vue&type=style&index=0&id=2669f006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2669f006",
  null
  
)

export default component.exports